import { useEffect, useRef } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import { doCampusAuth } from "../Api/authentication";
import Spinner from "../components/Spinner/Spinner";
import { useSelector } from "react-redux";
import { selectStudent } from "../reduxSlices/studentSlice";
import { useToastError } from "../hooks/useToast";
import { EstadoAlumnoCarrera } from "../enums/alumnoCarrera.enum";
import { useAuth } from "../hooks/useAuth";

const Campus = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const showError = useToastError();
  const student = useSelector(selectStudent);
  const { setMulticarrera, setCarrerasList, setInicializoConMultiCarrera, handleAuthResponse } =
    useAuth();
  const tokenParam = searchParams.get("token");
  const hasAuthenticated = useRef(false);
  const retryCount = useRef(0);

  const isRetryableError = (error: any) => {
    if (error?.status === 500 || error?.code === "ERR_BAD_RESPONSE") {
      return true;
    }
    if (!error.response) return true;
    const status = error.response?.status;
    if (status >= 500) return true;
    if (error.code === 'ECONNABORTED') return true;
    if (error.code === 'ENOTFOUND' || error.code === 'ECONNREFUSED') return true;
    return false;
  };

  useEffect(() => {
    const token = localStorage.getItem("token");
    const campusToken = localStorage.getItem("campusToken");
    const autenticarCampus = async (currentRetryCount: number = 0) => {
      const delay = currentRetryCount === 0 ? 1500 : 3000;
      if (!tokenParam) {
        showError("Token no proporcionado");
        console.log("TOKEN NO PROPORCIONADO>> REDIRIGIENDO A LOGIN", {token, campusToken});
        navigate("/login");
        return;
      }

      if (hasAuthenticated.current) return;

      try {
        localStorage.setItem("campusToken", tokenParam);
        const {data, status} = await doCampusAuth(tokenParam);
        if (data?.error && isRetryableError(data.error) && currentRetryCount < 3) {
          retryCount.current = currentRetryCount + 1;
          setTimeout(() => {
            autenticarCampus(currentRetryCount + 1);
          }, delay);
          return;
        }

        hasAuthenticated.current = true;
        await handleAuthResponse(data, true); 
      } catch (err) {
        if (isRetryableError(err) && currentRetryCount < 3) {
          retryCount.current = currentRetryCount + 1;
          setTimeout(() => {
            autenticarCampus(currentRetryCount + 1);
          }, delay);
          return;
        }

        hasAuthenticated.current = true;
        showError("Error de autenticación. Por favor intente nuevamente.");
        window.location.href = "https://campusvirtual.utdt.edu";
      }
    };

    autenticarCampus();
  }, [tokenParam, navigate, handleAuthResponse, showError]);

  useEffect(() => {
    const token = localStorage.getItem("token");
    if (!student.id || !student.studentInitState || !token || !student.listadoCarreras?.length) {
      return;
    }
    if (student.studentInitState === EstadoAlumnoCarrera.INICIALIZACION_KV_PENDIENTE) {
      return;
    }
    if (student.listadoCarreras.length === 1) {
      navigate("/");
    } else {
      setInicializoConMultiCarrera(true);
      setCarrerasList(student.listadoCarreras);
      setMulticarrera(true);
      navigate("/seleccioncarrera");
    }
  }, [student, navigate, setCarrerasList, setInicializoConMultiCarrera, setMulticarrera]);

  return (
    <div className="flex justify-center items-center h-screen">
      <Spinner />
    </div>
  );
};

export default Campus;